import { Chip, Grid, Tooltip } from "@mui/material";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { EnumHistory } from "enum/enum";
import { useEffect, useState } from "react";
import { FnAxios, FnDialog } from "utilities/utilities";
import { FormProvider, useForm } from "react-hook-form";
import { BtnClear, BtnSearch } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { useLocation } from "react-router";
import STTable from "components/STTable";
import { STTableColumnDetail, STTableRow } from "components/STTable/STTableProps";

const HistoryReport = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const location = useLocation();
    const [loadingTable, setLoadingTable] = useState(false);
    const [arrMenu, setArrMenu] = useState([]);
    const [arrUser, setArrUser] = useState([]);
    const [isView, setisView] = useState(true);

    const currentDate = new Date(); // Get the current date
    const _dStart = new Date(currentDate.getFullYear(), 0, 1); //01/01/New
    const _dEnd = new Date(currentDate.getFullYear(), 12, 0); //31/12/New

    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sDate",
        sSortDirection: "desc"
    });

    // const [dataRow, setDataRow] = useState<STTableRow>({
    //     ...initRows,
    //     sSortExpression: "sDate",
    //     sSortDirection: "desc"
    // });

    const form = useForm({
        shouldUnregister: false,
        shouldFocusError: true,
        mode: "all"
    });

    const getFormInitial = () => {
        AxiosFn.Get(`HistoryReport/GetFormInitial`, {}, (result) => {
            setArrMenu(result.objResult?.lstMenu);
            setArrUser(result.objResult?.lstUser);
        });
    }

    // const getTable = (p: PaginationInterface) => {
    const getTable = (p: STTableRow) => {
        setLoadingTable(true);

        let nDateStart = form.getValues("dStartDate") ? form.getValues("dStartDate").valueOf() : null;
        let nDateEnd = form.getValues("dEndDate") ? form.getValues("dEndDate").valueOf() : null;

        let param = {
            ...p,
            lstNameSearch: form.getValues("lstNameSearch") ?? [],
            lstMenuSearch: form.getValues("lstMenuSearch") ?? [],
            nStartDate: nDateStart,
            nEndDate: nDateEnd,
        }

        AxiosFn.Post(`HistoryReport/GetTable`, param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: result.lstHistory ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    const handleDelete = (e) => {
        let param = {
            lstID: e,
            sLocation: location.pathname,
            nType: 1
        }

        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`HistoryReport/OnDelete`, param, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTable(dataRow);
                    });
                }
            });
        });
    }

    const dataColumn: any = [
        {
            field: 'sDate',
            headerName: 'วันที่',
            headerAlign: 'center',
            minWidth: 120,
            sortable: true,
            align: "center",
        },
        {
            field: 'sTime',
            headerName: 'เวลา',
            headerAlign: 'center',
            align: 'center',
            minWidth: 120,
            editable: true
        },
        {
            field: 'sUserName',
            headerName: 'ชื่อผู้เข้าใช้งาน',
            headerAlign: 'center',
            bodyAlign: 'left',
            minWidth: 300,
            editable: true
        },
        {
            field: 'sMenuName',
            headerName: 'เข้าใช้งานเมนู',
            headerAlign: 'center',
            bodyAlign: 'left',
            minWidth: 370,
            editable: true,
            flex: 1
        },
        {
            field: 'sActionName',
            headerName: 'ลักษณะการเข้าใช้งานเมนู',
            headerAlign: 'center',
            align: 'center',
            minWidth: 180,
            editable: true,
            renderCell: (item) => {
                return (
                    <>
                        {EnumHistory.view === item.row.nActionID &&
                            <Tooltip title={item.row.sActionName}>
                                <Chip
                                    size="medium"
                                    label={item.row.sActionName}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumHistory.edit === item.row.nActionID &&
                            <Tooltip title={item.row.sActionName}>
                                <Chip
                                    size="medium"
                                    label={item.row.sActionName}
                                    style={{
                                        color: "#f2b908",
                                        backgroundColor: "#FFFBF0",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumHistory.delete === item.row.nActionID &&
                            <Tooltip title={item.row.sActionName}>
                                <Chip
                                    size="medium"
                                    label={item.row.sActionName}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },
    ];

    useEffect(() => {
        getFormInitial();
        getTable(dataRow);
    }, []);

    return (
        <>
            <Grid container spacing={1} justifyItems={'flex-start'} justifyContent={'start'} sx={{ mb: "2%" }}>
                <FormProvider {...form}>
                    <Grid item xs={12} md={3.4}>
                        <MultipleSelectItem
                            id={"lstNameSearch"}
                            name={"lstNameSearch"}
                            label={"ชื่อผู้เข้าใช้งาน"}
                            required={false}
                            options={arrUser}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item xs={12} md={3.8}>
                        <MultipleSelectItem
                            id={"lstMenuSearch"}
                            name={"lstMenuSearch"}
                            label={"ชื่อเมนู"}
                            required={false}
                            options={arrMenu}
                            limitTag={1}
                        />
                    </Grid>
                    <Grid item xs={12} md={1.75}>
                        <DatePickerItem
                            name={"dStartDate"}
                            id={"dStartDate"}
                            label={"วันที่เริ่มต้น"}
                            fullWidth={true}
                            required={false}
                            disabled={false}
                            maxDate={form.watch("dEndDate")}
                        />
                    </Grid>
                    <Grid item xs={12} md={1.75}>
                        <DatePickerItem
                            name={"dEndDate"}
                            id={"dEndDate"}
                            label={"วันที่สิ้นสุด"}
                            fullWidth={true}
                            required={false}
                            disabled={false}
                            minDate={form.watch("dStartDate")}
                        />
                    </Grid>
                    <Grid item xs={12} md={1.3} container spacing={1} justifyItems={'flex-start'} justifyContent={'end'}>
                        <Grid item>
                            <BtnClear id={'btnClearSearchAll'} IsCircleWithOutText={true} onClick={() => { form.reset(); getTable(dataRow); }} />
                            {/* icon={<ClearIcon />}  */}
                        </Grid>
                        <Grid item>
                            <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={true} onClick={() => { getTable(dataRow); }} />
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>

            {isView ?
                <Grid item xs={12}>
                    <DataGrid
                        sTableID='tableHistoryReport'
                        columns={dataColumn}
                        rows={dataRow}
                        modeFilter={1}
                        isLoading={loadingTable}
                        onLoadData={getTable}
                        isShowCheckBox={true}
                        isHiddenToolHead
                        onDelete={handleDelete}
                        onRowSelectable={(p) => p.row.isCanDelete}
                    />
                </Grid>
                : null}
        </>
    );
}

export default HistoryReport;